import 'CssFolder/components/steps.scss';

const Steps = {
  view: ({ attrs: { steps, currentStep } }) => {
    return m(
      "div.steps",
      steps.map((step, index) =>
        m(
          "div.step",
          {
            class: [
              "step",
              step.id < currentStep ? "completed" : "",
              step.id === currentStep ? "current" : "",
            ].join(" "),
          },
          [
            m("div.step-icon", step.id < currentStep ? m('i', {"class": "bi bi-check-lg", style: {"margin": "0px"}}) : step.id),
            m("div.step-content", [
              m("div.step-title", step.title),
              m("div.step-description", step.description),
            ]),
          ]
        )
      )
    );
  },
};

export default Steps;